export const STEADFAST_LOGO = "https://customer-assets.emergentagent.com/job_data-essentials/artifacts/je98n6d2_logo.png";
export const CONTACT_EMAIL = "operations@steadfastitconsulting.in";
export const COMPANY_NAME = "Steadfast IT Consulting";
export const COURSE_TITLE = "Data Science & Analytics";
